// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { colorGuard, brandingGuard, languageInfoGuard, termsOfUseGuard, signInGuard, signUpGuard, connectorTargetsGuard, } from '../foundations/index.js';
import { SignInMode } from './custom-types.js';
const createGuard = z.object({
    id: z.string().max(21),
    color: colorGuard,
    branding: brandingGuard,
    languageInfo: languageInfoGuard,
    termsOfUse: termsOfUseGuard,
    signIn: signInGuard,
    signUp: signUpGuard,
    socialSignInConnectorTargets: connectorTargetsGuard.optional(),
    signInMode: z.nativeEnum(SignInMode).optional(),
});
const guard = z.object({
    id: z.string().max(21),
    color: colorGuard,
    branding: brandingGuard,
    languageInfo: languageInfoGuard,
    termsOfUse: termsOfUseGuard,
    signIn: signInGuard,
    signUp: signUpGuard,
    socialSignInConnectorTargets: connectorTargetsGuard,
    signInMode: z.nativeEnum(SignInMode),
});
export const SignInExperiences = Object.freeze({
    table: 'sign_in_experiences',
    tableSingular: 'sign_in_experience',
    fields: {
        id: 'id',
        color: 'color',
        branding: 'branding',
        languageInfo: 'language_info',
        termsOfUse: 'terms_of_use',
        signIn: 'sign_in',
        signUp: 'sign_up',
        socialSignInConnectorTargets: 'social_sign_in_connector_targets',
        signInMode: 'sign_in_mode',
    },
    fieldKeys: [
        'id',
        'color',
        'branding',
        'languageInfo',
        'termsOfUse',
        'signIn',
        'signUp',
        'socialSignInConnectorTargets',
        'signInMode',
    ],
    createGuard,
    guard,
});
